// extracted by mini-css-extract-plugin
export var locationCard = "_gm-0";